import Location from "@/model/location";
import api from "./api";

class PostalCodeApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async listOfProperty(data = null): Promise<Location[]> {
    const response = await this.getHttp().get<any>("/postal-codes", {
      params: {
        has_property: 1,
      },
      data
    });

    return response.data.data.map((item) => {
      return new Location(item);
    });
  }

  async show(code): Promise<any> {
    const response = await this.getHttp().get<any>("/postal-codes/" + code, {
      data: {
        noRedirect: true,
      },
    });
    if (response.status === 200) {
      return new Location(response.data.data);
    }
  }
}
export default new PostalCodeApi();
